// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-table-invalid[data-v-99fd160a] {\n    border: 1px solid red;\n    border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
